import SystemFieldProto from "../../proto/system-field-proto";
import ListComponent from './components/story-points-list';
import ListGroupHeaderComponent from './components/story-points-group-list-header'
import ViewComponent from './components/story-points-view';
import IconComponent from './components/story-points-icon';
import AggregateNumber from "../../aggregate/aggregate-number";
import FieldShortTextViewInImport from "../../import/view-in-preview/short-text-in-preview";
import AggregateStoryPointsComponent from "./components/aggregate-story-points";

export default class StoryPointsField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.STORY_POINTS;
        this.valueType = gd.const.fields.valueType.FLOAT;
        this.formulaCompatible = true;
    }

    static getValue(item) {return item.storyPoints}

    get sortHintMessage() {
        return 'Sort by story points';
    }

    getAggregateValue(item) {
        return StoryPointsField.getValue(item);
    }

    getCsvValue(item) {
        return StoryPointsField.getValue(item);
    }

    getValue(item) {return StoryPointsField.getValue(item)}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.AVERAGE,
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    getGroupObject(value) {
        const storyPoints = gd.session.companies.get(gd.companyId).settings.fields.storyPoints;
        const found = _.find(storyPoints, sp=>sp.value === value);

        return {
            id: found ? found.value : value,
            value: found ? found.value : value,
            label: found ? found.label : value,
            name: _.get(found, 'label', 'Not selected'),
        }
    }

    listItemGroupFunction() {
        return i=>StoryPointsField.getValue(i.item);
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => StoryPointsField.getValue(i.item) || 0],
            directions: [sort]
        }
    }

    get ListComponent() {return ListComponent.bind(null);}
    get ListGroupHeaderComponent() {return ListGroupHeaderComponent.bind(null);}
    get ViewComponent() {return ViewComponent.bind(null);}
    get IconComponent() {return IconComponent.bind(null);}

    get AggregateComponent() {return AggregateStoryPointsComponent.bind(null, this.getAggregateOptions());}

    // IMPORT

    normalizeCSVValue(value) {
        return value ? value.trim() : null;
    }

    getComponentViewInImport() {
        return FieldShortTextViewInImport;
    }

}